import { WizardStepPage } from '../WizardStepPage/view';
import { PlacementOptionsView } from './PlacementOptionsView/view';
import { EquipmentStepView } from '../EquipmentStepView/view';
import { DeviceNameStepView } from '../DeviceNameStepView/view';

export const PlacementStepView = WizardStepPage.extend({
    template: '#tpl_placement_step',
    stepNumberKey: 'mobile_sensors_wizard_step_one',
    stepTitleKey: 'mobile_sensor_placement_description',
    nextStepViewClass: DeviceNameStepView,

    onRender: function () {
        this.displayPlacementOptions();
        this.updateNextButtonState(this.isNextButtonEnabled());
    },

    regions: {
        r_placement_options: '.r_placement_options'
    },

    displayPlacementOptions: function () {
        this.r_placement_options.show(
            new PlacementOptionsView({
                model: this.model.get('placement'),
                onSelect: (placement) => {
                    this.model.set('placement', placement);
                    this.updateNextButtonState(this.isNextButtonEnabled());
                }
            })
        );
    },

    isNextButtonEnabled: function () {
        return !!this.model.get('placement');
    },

    displayNextStep: function () {
        if (!this.isNextButtonEnabled()) {
            return;
        }

        // TODO: IOT-1192 release - remove hasSensorEquipmentReadings usage
        const hasSensorEquipmentReadings = $f.active_company.has_feature('sensor_equipment_readings');

        if (hasSensorEquipmentReadings) {
            $f.mobile.nav.show(EquipmentStepView, {
                model: this.model,
                stepNumberKey: this.nextStepNumberKey,
                selectedManufacturer: this.selectedManufacturer
            });
            return;
        }

        $f.mobile.nav.show(DeviceNameStepView, {
            model: this.model,
            stepNumberKey: this.nextStepNumberKey,
            selectedManufacturer: this.selectedManufacturer
        });
    }
});
